import { REST } from './utils';

const { GET, POST } = REST('/user/orcid');

export const getOrcidURL = (): Promise<string> => GET('/url/orcid-integration');

export const getAffiliations = async (code: string, skipProfileAffiliations: boolean = true): Promise<Affiliation[]> =>
    (await GET('/data', { code, skipProfileAffiliations })).affiliations;

export const importAffiliations = (code: string): Promise<void> => POST(`/affiliations/import/${code}`);

export const importAffiliationsInRegistration = (code: string, registToken: string): Promise<void> =>
    POST(`/affiliations/import/${code}/${registToken}`);

export const getData = (
    code: string,
    skipProfileAffiliations: boolean = false,
): Promise<{
    user: {
        firstName: string;
        lastName: string;
        primaryEmailAddr: string;
        orcidId: string;
    };
    affiliations: Affiliation[];
}> => GET('/data', { code, skipProfileAffiliations });
